import { render, staticRenderFns } from "./driver-info.vue?vue&type=template&id=a4bc5c86&"
import script from "./driver-info.vue?vue&type=script&lang=js&"
export * from "./driver-info.vue?vue&type=script&lang=js&"
import style0 from "./driver-info.vue?vue&type=style&index=0&id=a4bc5c86&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports